import { useAuthContext } from '../../../../context/auth.context'
import { isImpersonating } from '../../../../shared/audit/use-audit-capabilities'
import { useRoleSysErrors, useRoleSysAlertRouting, useRoleSysRequestLog } from '../../../../role/hook/role-sys'

export const READ_ONLY = "You're signed in as someone else, so errors can be viewed but not changed. End the impersonation to make changes."

// What the Errors pages may show: triage (SYS_ERRORS update, and not while
// impersonating: content refuses every triage write from such a session),
// a sample's request (SYS_REQUEST_LOG read) and the group's alerts
// (SYS_ALERT_ROUTING read). readOnly: triage is withheld only because of
// the impersonation, so the page says why.
export const useErrorRoles = () => {
  const { state } = useAuthContext()
  const impersonating = isImpersonating(state || {})
  const errors = useRoleSysErrors()
  const requestLog = useRoleSysRequestLog()
  const routing = useRoleSysAlertRouting()
  const mayUpdate = Boolean(errors.accessUpdate)
  return {
    canTriage: mayUpdate && !impersonating,
    readOnly: mayUpdate && impersonating,
    canOpenRequest: Boolean(requestLog.accessRead),
    canSeeAlerts: Boolean(routing.accessRead)
  }
}
